/*
    description:
    Full-screen intro video shown once per browser session before the site.
*/
import { useState, useMemo } from 'react';
import { Box, Fade } from '@mui/material';

const SESSION_KEY = 'introVideoShown';

// Safari can throw SecurityError on sessionStorage access (private
// browsing, blocked cookies, non-standard origins like a bare LAN IP)
// so any read/write must be guarded to avoid crashing the whole app.
const safeSessionStorage = {
  get(key) {
    try {
      return sessionStorage.getItem(key);
    } catch {
      return null;
    }
  },
  set(key, value) {
    try {
      sessionStorage.setItem(key, value);
    } catch {
      // ignore — worst case the intro replays next load
    }
  },
};

function IntroSplash() {
  const [visible, setVisible] = useState(() => !safeSessionStorage.get(SESSION_KEY));

  const videoSrc = useMemo(
    () => (window.matchMedia('(max-width: 600px)').matches
      ? '/videos/intro-mobile.mp4'
      : '/videos/intro.mp4'),
    []
  );

  const dismiss = () => {
    safeSessionStorage.set(SESSION_KEY, 'true');
    setVisible(false);
  };

  return (
    <Fade in={visible} timeout={500} unmountOnExit>
      <Box
        sx={{
          position: 'fixed',
          inset: 0,
          zIndex: 2000,
          backgroundColor: 'black',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <video
          src={videoSrc}
          autoPlay
          muted
          playsInline
          onEnded={dismiss}
          onError={dismiss}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
          }}
        />
      </Box>
    </Fade>
  );
}

export default IntroSplash;
